/* import __COLOCATED_TEMPLATE__ from './shared-react-mfe-component-mount.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import * as Sentry from '@sentry/browser';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { importBundle } from '@dashboard/junk-drawer/utils/dynamic-import-util';
let SharedReactMfeComponentMount = (_class = class SharedReactMfeComponentMount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "failureMessage", _descriptor, this);
    _initializerDefineProperty(this, "mountFailure", _descriptor2, this);
    _initializerDefineProperty(this, "sharedReactMfe", _descriptor3, this);
    _initializerDefineProperty(this, "queryClient", _descriptor4, this);
    _defineProperty(this, "reactRoot", void 0);
    _defineProperty(this, "renderComponent", () => {
      // eslint-disable-next-line no-console
      console.log('Error: Called renderComponent before bootstrapComponent was called');
    });
  }
  async setupComponent(domElement) {
    try {
      const {
        manifest
      } = await this.sharedReactMfe.getManifest();
      const appSrc = `${manifest.cdnOrigin}/${manifest.main}`;
      await this.mountComponent(appSrc, domElement);
    } catch (e) {
      this.handleMountFailure(e);
    }
  }
  async mountComponent(appSrc, domElement) {
    // babel is giving me guff about dynamic importing
    // from a variable, which we need since the CDN changes
    // for staging and prod. We have to do this hack to please
    // the babel overlords for the time being

    const importedModule = await importBundle(appSrc);
    const {
      root,
      renderComponent
    } = await importedModule.bootstrapComponent(this.args.componentName, {
      ...this.args.props,
      queryClient: this.queryClient.instance,
      queryClientV5: this.queryClient.instanceV5
    }, domElement);
    this.reactRoot = root;
    this.renderComponent = renderComponent;
  }
  updateComponent() {
    if (typeof this.renderComponent === 'function') {
      this.renderComponent({
        ...this.args.props,
        queryClient: this.queryClient.instance,
        queryClientV5: this.queryClient.instanceV5
      });
    }
  }
  teardownComponent() {
    this.reactRoot?.unmount();
    this.reactRoot = undefined;
  }
  handleMountFailure(error) {
    Sentry.captureException(error);
    this.mountFailure = true;
    if (error instanceof Error) {
      this.failureMessage = error.message;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "failureMessage", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mountFailure", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sharedReactMfe", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "queryClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setupComponent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setupComponent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateComponent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateComponent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teardownComponent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "teardownComponent"), _class.prototype), _class);
export { SharedReactMfeComponentMount as default };